<div *ngIf="sidebarAberta" class="overlay" (click)="hideSidebar()"></div>

<div class="sidebar-container" [class.sidebar-fechada]="!sidebarAberta">
  <sidebar-logo *ngIf="sidebarAberta"></sidebar-logo>

  <sidebar-logo-small *ngIf="!sidebarAberta"></sidebar-logo-small>

  <hr
    style="margin-left: 8px; margin-right: 8px; color: ' ##e9eaee'"
    *ngIf="!sidebarAberta"
  />

  <nav class="sidebar-menu">
    <sidebar-menu [route]="rota"></sidebar-menu>
  </nav>

  <ul class="navbar-nav" [class.navbar-nav-fechada]="sidebarAberta">
    <li>
      <sidebar-user-menu [route]="rota"></sidebar-user-menu>
    </li>
  </ul>
</div>
